const getSharedMappingReason = (mapping: any, mappingGroup: any) => {
    const reason = mapping?.reason ?? mappingGroup?.reason;
    return Array.isArray(reason) ? reason.join(' ') : (reason || '');
};

const normalizeRedMappingGroup = (redGroup: any, blueAllMappings: any[] = []) => {
    const blueIndex = Number(redGroup?.feature_index) - 1;
    const blueGroup = Number.isInteger(blueIndex) ? blueAllMappings[blueIndex] : null;
    const sourceMappings = Array.isArray(redGroup?.mappings) && redGroup.mappings.length > 0
        ? redGroup.mappings
        : (blueGroup?.mappings || []);

    return {
        ...blueGroup,
        ...redGroup,
        reason: redGroup.reason || blueGroup?.reason || '',
        mapping_label: redGroup.mapping_label || blueGroup?.mapping_label,
        review_action: redGroup.review_action,
        review_analysis: redGroup.review_analysis || '',
        review_challenge: redGroup.review_analysis || redGroup.reason || '',
        review_evidence_strength: redGroup.evidence_strength,
        mappings: sourceMappings.map((mapping: any) => ({
            ...mapping,
            reason: getSharedMappingReason(mapping, redGroup) || getSharedMappingReason(mapping, blueGroup),
            mapping_label: mapping.mapping_label || redGroup.mapping_label || blueGroup?.mapping_label,
            review_action: redGroup.review_action,
            review_analysis: redGroup.review_analysis || '',
            review_challenge: redGroup.review_analysis || redGroup.reason || '',
            review_evidence_strength: redGroup.evidence_strength,
        })),
    };
};

const normalizeDeleteMappings = (mappingGroup: any) => {
    const deleteMappings = Array.isArray(mappingGroup?.delete_mappings)
        ? mappingGroup.delete_mappings
        : [];

    return deleteMappings.map((deleteMapping: any) => ({
        ...deleteMapping,
        isDeleted: true,
        reason: mappingGroup.reason || '',
        mapping_label: mappingGroup.mapping_label,
        review_action: mappingGroup.review_action,
        review_analysis: mappingGroup.review_analysis || '',
        review_challenge: mappingGroup.review_analysis || mappingGroup.reason || '',
        review_evidence_strength: mappingGroup.evidence_strength,
        entity_mapping: {},
    }));
};

export const normalizeRedRevisionMappingGroup = (redGroup: any, blueAllMappings: any[] = []) => {
    const normalizedGroup = normalizeRedMappingGroup(redGroup, blueAllMappings);
    const deletedMappings = normalizeDeleteMappings(normalizedGroup);
    const hasRedMappings = Array.isArray(redGroup?.mappings) && redGroup.mappings.length > 0;

    if (deletedMappings.length === 0) {
        return normalizedGroup;
    }

    const revisionMappings = hasRedMappings
        ? (normalizedGroup.mappings || [])
        : [{
            isEmpty: true,
            reason: normalizedGroup.reason || '',
            mapping_label: normalizedGroup.mapping_label,
            review_action: normalizedGroup.review_action,
            review_analysis: normalizedGroup.review_analysis || '',
            review_challenge: normalizedGroup.review_challenge || '',
            review_evidence_strength: normalizedGroup.review_evidence_strength,
            stance_strength: normalizedGroup.stance_strength,
            entity_mapping: {},
        }];

    return {
        ...normalizedGroup,
        mappings: [
            ...deletedMappings,
            ...revisionMappings
        ],
    };
};
